const b = require('app/www/libs/b')('adFox');

const React = require('react');
const PropTypes = require('prop-types');

const randomString = require('app/www/libs/randomString');
const Metrika = require('app/www/libs/client/metrika');

const Global = require('app/www/components/blocks/Global/Global');

const LOADER_URL = '//yastatic.net/pcode/adfox/loader.js';

class AdFox extends React.PureComponent {

    constructor(props) {
        super(props);

        this._onLoad = this._onLoad.bind(this);
        this._onError = this._onError.bind(this);
        this._loadScript = this._loadScript.bind(this);
    }

    componentDidMount() {
        this.block.id = randomString();

        this._loadScript();
    }

    render() {
        return (
            <div className={b()} data-url={LOADER_URL} ref={ref => (this.block = ref)}>
                <div id={this.props.containerId} />
            </div>
        );
    }

    /**
     * @private
     */
    _onLoad() {
        Metrika.trackParams('ADFOX_ADVMANAGER_RESPONSE', {
            id: this.props.containerId,
            flag: true,
        });

        this.props.onLoad();
    }

    /**
     * @private
     */
    _onError() {
        Metrika.trackParams('ADFOX_ADVMANAGER_RESPONSE', {
            id: this.props.containerId,
            flag: false,
        });

        this.props.onError();
    }

    /**
     * Грузим скрипт AdFox
     * @private
     */
    _loadScript() {
        const {
            params,
            ownerId,
            containerId,
        } = this.props;

        params.puid1 = Global.nonce;

        ((w, d, n) => {
            w[n] = w[n] || [];
            w[n].push({
                params,
                ownerId,
                containerId,
                onLoad: this._onLoad,
                onError: this._onError,
                cspNonce: Global.nonce,
            });

            const createScript = () => {
                const t = d.getElementsByTagName('script')[0];
                const s = d.createElement('script');
                s.src = LOADER_URL;
                s.type = 'text/javascript';
                s.onerror = () => this._onError();
                s.onload = () => {};
                s.async = true;
                s.setAttribute('crossorigin', 'anonymous');
                t.parentNode.insertBefore(s, t);
            };

            if (d.readyState === 'complete') {
                createScript();
            } else if (d.addEventListener) {
                w.addEventListener('load', createScript);
            } else {
                w.attachEvent('onload', createScript);
            }
        })(window, document, 'adfoxAsyncParams');
    }
}

AdFox.defaultProps = {
    onLoad: () => {},
    onError: () => {},
};

AdFox.propTypes = {
    ownerId: PropTypes.number,
    containerId: PropTypes.string,
    statId: PropTypes.number,
    onError: PropTypes.func,
    onLoad: PropTypes.func,
};

module.exports = AdFox;
